import { CentreDto, CentreTypeSelector } from 'api';

const CentrePrefix = 'BC';
const IdpCentrePrefix = 'Idp';

export function getCentresIds(values: string[] | undefined) {
  return values !== undefined
    ? values
        .filter((x) => x.startsWith(CentrePrefix) || x.startsWith(IdpCentrePrefix))
        .map((x) =>
          x.startsWith(CentrePrefix)
            ? Number(x.substring(CentrePrefix.length))
            : Number(x.substring(IdpCentrePrefix.length))
        )
    : [];
}

export function getBcCentresIds(values: string[] | undefined) {
  return values !== undefined
    ? values
        .filter((x) => x.startsWith(CentrePrefix))
        .map((x) => Number(x.substring(CentrePrefix.length)))
    : [];
}

export function getIdpCentresIds(values: string[] | undefined) {
  return values !== undefined
    ? values
        .filter((x) => x.startsWith(IdpCentrePrefix))
        .map((x) => Number(x.substring(IdpCentrePrefix.length)))
    : [];
}

export function getCentreValue(id: number, isIdp: boolean) {
  return isIdp ? IdpCentrePrefix + id : CentrePrefix + id;
}

export function getCentreId(value: string) {
  return value.startsWith(CentrePrefix)
    ? Number(value.substring(CentrePrefix.length))
    : Number(value.substring(IdpCentrePrefix.length));
}

export function getCentreFullName(centre: CentreDto, type: CentreTypeSelector): string {
  let text = '';

  if (centre.centreNumberIdentifier === null) {
    text = text + centre.name;
  } else {
    text = text + centre.centreNumberIdentifier;
    if (centre.name !== null) {
      text = text + ' - ' + centre.name;
    }
  }

  if (!centre.isActive) {
    text = text + ' - inactive';
  }

  if (CentreTypeSelector.ALL === type) {
    text = centre.isIdp ? text + ' - IDP' : text + ' - BC';
  }

  return text;
}
